import { acaoSobDemanda, telaSobDemanda } from '../../nucleo/paginas/TelaSobDemanda';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../../nucleo/api';
import type { ModuloWeb } from '../../nucleo/modulos';
import { CartaoIndicador } from '../../nucleo/ui/Estados';
import { dicionario } from './i18n';
import { formatarDinheiro } from './tipos';

/** F10: indicadores do Financeiro no Início. */
function Indicadores() {
  const { t, i18n } = useTranslation('financeiro');
  const q = useQuery({
    queryKey: ['financeiro', 'resumo'],
    queryFn: () => api<{ totais: { moeda: string; saldo_centavos: string }[]; mes_entradas_centavos: string; mes_saidas_centavos: string; pendentes_conciliacao: number }>('/api/v1/financeiro/resumo'),
  });
  const brl = q.data?.totais.find((x) => x.moeda === 'BRL')?.saldo_centavos ?? '0';
  const resultado = q.data ? (BigInt(q.data.mes_entradas_centavos) - BigInt(q.data.mes_saidas_centavos)).toString() : null;
  const itens = [
    { rotulo: t('indicadores.saldo'), valor: q.data ? formatarDinheiro(brl, 'BRL', i18n.language) : null },
    { rotulo: t('indicadores.resultadoMes'), valor: resultado !== null ? formatarDinheiro(resultado, 'BRL', i18n.language, true) : null },
    { rotulo: t('indicadores.pendentes'), valor: q.data ? String(q.data.pendentes_conciliacao) : null },
  ];
  // ROB-01: o CartaoIndicador do núcleo distingue carregando (reticências) de erro (traço e Tentar de novo).
  return (
    <>
      {itens.map((i) => (
        <CartaoIndicador key={i.rotulo} rotulo={i.rotulo} valor={i.valor !== null ? <span className="break-all">{i.valor}</span> : null} consultas={[q]} />
      ))}
    </>
  );
}

const carregar0 = () => import(
  "./Lancamentos"
);
const carregar1 = () => import('./Contas');
const carregar2 = () => import('./Classificacao');
const carregar3 = () => import('./Conciliacao');
const carregar4 = () => import('./FluxoCaixa');

const AcaoLancamentos = acaoSobDemanda(carregar0, 'AcaoLancamentos');
const FichaLancamento = telaSobDemanda(carregar0, 'FichaLancamento');
const Lancamentos = telaSobDemanda(carregar0, 'Lancamentos');
const AcaoContas = acaoSobDemanda(carregar1, 'AcaoContas');
const Contas = telaSobDemanda(carregar1, 'Contas');
const FichaConta = telaSobDemanda(carregar1, 'FichaConta');
const Categorias = telaSobDemanda(carregar2, 'Categorias');
const CentrosCusto = telaSobDemanda(carregar2, 'CentrosCusto');
const Conciliacao = telaSobDemanda(carregar3, 'Conciliacao');
const FluxoCaixa = telaSobDemanda(carregar4, 'FluxoCaixa');

export const modulo: ModuloWeb = {
  slug: 'financeiro',
  menu: 'financeiro',
  dicionario,
  abas: [
    { rotulo: 'abas.lancamentos', caminho: 'entradas-e-saidas', elemento: <Lancamentos />, Acao: AcaoLancamentos, ordem: 1 },
    { rotulo: 'abas.contas', caminho: 'contas-e-caixas', elemento: <Contas />, Acao: AcaoContas, ordem: 2 },
    { rotulo: 'abas.categorias', caminho: 'categorias', elemento: <Categorias />, ordem: 3 },
    { rotulo: 'abas.centros', caminho: 'centros-de-custo', elemento: <CentrosCusto />, ordem: 4 },
    { rotulo: 'abas.conciliacao', caminho: 'conciliacao', elemento: <Conciliacao />, ordem: 5 },
    { rotulo: 'abas.fluxo', caminho: 'fluxo-de-caixa', elemento: <FluxoCaixa />, ordem: 6 },
  ],
  rotas: [
    { path: 'financeiro/lancamentos/:id', element: <FichaLancamento /> },
    { path: 'financeiro/contas/:id', element: <FichaConta /> },
  ],
  Indicadores,
};
